// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"b4d3546c","454":"20e8798e"}[chunkId] + ".chunk.css";
};